import React from 'react';
import { SideBarItems } from 'components/Sidebar';
import {
    SpaceDashboardOutlined,
    MotionPhotosAutoOutlined
  } from "@mui/icons-material";
import StorageIcon from '@mui/icons-material/Storage';
import InsightsIcon from '@mui/icons-material/Insights';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';
import { Overview } from './Overview';
import { Tenant } from './Tenant/Tenant';
import { Report } from './Report';
import { Pod } from './Pod';
import { TestJob } from './TestJob';
export const ModulesMenu: SideBarItems[] = [{
    path:"/",
    urlKey: "automate-test",
    text: "Automate Test",
    icon: <MotionPhotosAutoOutlined />,
    type: "menuHeader",
    requiredModule: "automatetest.ai",
    menuKey: "automateTest",
    items: [
      {
        path:"/automate-test/",
        urlKey: "overview",
        text: "Overview",
        icon: <SpaceDashboardOutlined />,
        type: "menuItem",
        menuKey: "automateTest",
        module: <Overview/>
      },
      {
        path:"/automate-test/",
        urlKey: "manage-tenant",
        text: "Manage Tenant",
        icon: <StorageIcon />,
        type: "menuItem",
        menuKey: "automateTest",
        module: <Tenant />,
      },
      {
        path:"/automate-test/",
        urlKey: "testJobs",
        text: "TestJobs",
        icon: <AssignmentTwoToneIcon />,
        type: "menuItem",
        menuKey: "automateTest",
        module: <TestJob />,
      },
      {
        path:"/automate-test/",
        urlKey: "pods",
        text: "Pods",
        icon: <DeviceHubIcon />,
        type: "menuItem",
        menuKey: "automateTest",
        module: <Pod />,
      },
      {
        path:"/automate-test/",
        urlKey: "reports",
        text: "Reports",
        icon: <InsightsIcon />,
        type: "menuItem",
        menuKey: "automateTest",
        module: <Report />,
      }
    ]
  }];